import React from 'react';
import { Tag, Tooltip } from 'antd';
import './index.css';
import { useSelector } from 'react-redux';
import genreSelectors from 'src/redux/selectors/genreSelectors';
import { StyledTag } from 'src/components/SelectedTag/styles';
import { invertColor } from 'src/utils/helpers';

const Tags = ({ values }) => {
  return (
    values?.map(value =>
      <Tooltip title={value.name}>
        <StyledTag textColor={invertColor(value.color, true)} color={value.color}>
          {value.name}
        </StyledTag>
      </Tooltip>
    )
  )
};

const CustomTags = ({ values }) => {
  const genres = useSelector(genreSelectors.genres);
  const genresData = Object.values(genres).filter(genre => values?.includes(genre.id));

  return (
    genresData?.length >= 5
      ?
      <Tooltip placement="topLeft" title={<Tags values={genresData} />}>
        <div className="tags-container">
          <Tags values={genresData} />
        </div>
      </Tooltip>
      :
      <Tags values={genresData} />
  )
}

export default CustomTags;